import { render, staticRenderFns } from "./TabLogUtilizacao.vue?vue&type=template&id=7f5133c3&scoped=true"
import script from "./TabLogUtilizacao.vue?vue&type=script&lang=js"
export * from "./TabLogUtilizacao.vue?vue&type=script&lang=js"
import style0 from "./TabLogUtilizacao.vue?vue&type=style&index=0&id=7f5133c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5133c3",
  null
  
)

export default component.exports